import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableWaitingRescission from "./components/TableWaitingRescission";

export function WaitingRescissionRegisterPage() {

  return (
    <ToastProvider>
      <Dashboard>
        <TableWaitingRescission />
        <Toast />
      </Dashboard>
    </ToastProvider>
  )
}